<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'dialogPassword',
})
</script>
<template>
  <ant-Modal v-model:open="state.dialog.visible" transition-name="" :centered="true"
    :wrap-class-name="'wrap-reset-pwd-dialog'" :width="'645px'" :ok-text="state.dialog.submitTxt" @ok="onSubmit"
    @cancel="closeDialog" :closable="false" :maskClosable="false">
    <div class="form-content">
      <a-form ref="formRef" :model="state.ruleForm" :rules="rules" layout="vertical" class="reset-pwd-form">
        <a-form-item name="pwd" label="新密码">
          <a-input-password v-model:value="state.ruleForm.pwd" placeholder="请输入新密码" :maxlength="20" :minlength="8"
            autocomplete="off" />
        </a-form-item>
        <a-form-item name="pwdT" label="确认密码">
          <a-input-password v-model:value="state.ruleForm.pwdT" placeholder="再次输入密码" :maxlength="20" :minlength="8"
            autocomplete="off" />
        </a-form-item>
      </a-form>
    </div>
  </ant-Modal>
</template>

<script setup lang="ts" name="dialogPassword">
import { reactive, ref } from 'vue'

const emit = defineEmits(['update'])

const formRef = ref()

const state = reactive({
  ruleForm: {
    userId: '',
    pwd: '',
    pwdT: ''
  },
  dialog: {
    visible: false,
    title: '重置密码',
    submitTxt: '修改'
  }
})

const validatePass = (_rule: any, value: string) => {
  if (!value) {
    return Promise.reject(new Error('请输入新密码'))
  }
  const reg = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&.,;:^#])[A-Za-z\d@$!%*?&.,;:^#]{8,20}$/
  if (!reg.test(value)) {
    return Promise.reject(new Error('密码需包含大小写字母、数字及特殊符号，长度8-20个字符'))
  }
  return Promise.resolve()
}

const validatePass2 = (_rule: any, value: string) => {
  if (!value) {
    return Promise.reject(new Error('请再次输入新密码'))
  }
  if (value !== state.ruleForm.pwd) {
    return Promise.reject(new Error('两次密码输入不一致'))
  }
  return Promise.resolve()
}

const rules = {
  pwd: [{ required: true, validator: validatePass, trigger: 'blur' }],
  pwdT: [{ required: true, validator: validatePass2, trigger: 'blur' }]
}

const openDialog = (id: any) => {
  state.ruleForm.userId = id
  state.ruleForm.pwd = ''
  state.ruleForm.pwdT = ''
  state.dialog.visible = true
}

const closeDialog = () => {
  state.dialog.visible = false
  state.ruleForm.pwd = ''
  state.ruleForm.pwdT = ''
  formRef.value?.resetFields()
}

const onSubmit = () => {
  formRef.value
    .validate()
    .then(() => {
      emit('update', {
        userId: state.ruleForm.userId,
        pwd: state.ruleForm.pwd
      })
    })
    .catch(() => { })
}

defineExpose({
  openDialog,
  closeDialog
})
</script>

<style scoped lang="less">
.form-content {
  padding: 30px 36px 30px 36px;
}

:global(.wrap-reset-pwd-dialog .ant-modal-footer) {
  padding-top: 26px;
}

.space-divider {
  height: 1px;
  background: #A0B8E5;
}

:deep(.ant-form-item) {
  margin-bottom: 0px;
  padding-bottom: 16px;
}

:deep(.ant-form-item-label > label) {
  font-size: 14px;
  line-height: 1;
  font-weight: 400;
}

:deep(.ant-input-affix-wrapper) {
  height: 40px;
  padding: 0 11px;
  border-radius: 4px;
  display: flex;
  align-items: center;
}

:deep(.ant-input-disabled) {
  height: 40px;
  border-color: #C5C5D3;
  border-radius: 4px;
}

:deep(.ant-select-selector) {
  height: 40px !important;
  display: flex;
  align-items: center;
  border-radius: 4px;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-input-affix-wrapper:not(:hover):not(.ant-input-affix-wrapper-focused)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(.ant-select:not(.ant-select-disabled):not(.ant-select-focused) .ant-select-selector:not(:hover)) {
  border-color: #C5C5D3;
}

// 只覆盖默认态，hover/focus 保留 Ant Design 蓝色
:deep(textarea.ant-input:not(:hover):not(:focus)) {
  border-color: #C5C5D3;
}

.reset-pwd-form {
  max-width: 400px;
  margin: 0 auto;
}

:deep(.reset-pwd-form .ant-form-item-label) {
  text-align: left;
  justify-content: flex-start;
  padding-left: 0;
}

:deep(.reset-pwd-form .ant-form-item-label > label) {
  font-size: 14px;
  font-weight: 400;
  color: #000;
}

.reset-pwd-dialog-title {
  font-size: 18px;
  font-weight: bold;
  color: #000;
}
</style>
